import React from "react";

import { WorkOrderTestTable } from "../../tables";
import { AddWorkOrderTestingDialog } from "../../dialogs";

import WorkOrderTestingBar from "./WorkOrderTestingBar";
import { StyledCardStack, StyledContainer } from "./styles";

export const WorkOrderTesting = ({ workOrderId }) => {
  return (
    <StyledContainer>
      <StyledCardStack gap="15px">
        <WorkOrderTestingBar />
        <WorkOrderTestTable workOrderId={workOrderId} />
      </StyledCardStack>
      <AddWorkOrderTestingDialog workOrderId={workOrderId} />
    </StyledContainer>
  );
};

export default WorkOrderTesting;
